import { css, cx, useTheme } from '@fable/theme'
import image1 from 'assets/images/hero/fable-book-club-app-2.webp'
import image2 from 'assets/images/hero/fable-book-club-moderators.webp'
import image3 from 'assets/images/hero/fable-book-club-avatars.webp'
import { useTypedSelector } from 'hooks'

export const MLPHeroImage = () => {
  const { mediaQueries } = useTheme()
  const { isVerifying } = useTypedSelector(({ auth }) => auth)

  const images = [
    { src: image1, altText: 'fable book club app' },
    { src: image2, altText: 'fable book club moderators' },
    { src: image3, altText: 'fable book club avatars' },
  ]

  return (
    <div
      className={css`
        margin-top: -20px;
        position: relative;
        display: block;
        width: 100%;
        height: 74vw;
        ${mediaQueries.mobileL} {
          margin-top: -30px;
          width: 732px;
          height: max(40.365vw, 400px);
        }
        ${mediaQueries.desktop} {
          height: 465px;
        }
        ${mediaQueries.desktopL} {
          height: 500px;
        }
      `}
    >
      <span
        className={css`
          position: absolute;
          top: 106px;
          left: 50%;
          width: 489px;
          height: 489px;
          background: radial-gradient(
            50% 50% at 50% 50%,
            #ffffff 0%,
            rgba(251, 250, 247, 0.544662) 70.15%,
            rgba(247, 244, 238, 0) 100%
          );
          border-radius: 50%;
          transform: translateX(-50%) rotate(90deg);
        `}
      />
      {images.map((image, i) => (
        <img
          key={i}
          className={cx(
            css`
              display: block;
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              object-fit: contain;
              object-position: center;
              opacity: 0;
              transform: translateY(200px);
              z-index: ${images.length - i};
            `,
            !isVerifying &&
              css`
                animation: appear 0.6s cubic-bezier(0.33, 1, 0.68, 1) forwards;
                animation-delay: ${i * 0.4}s;

                @keyframes appear {
                  from {
                    opacity: 0;
                    transform: translateY(100px);
                  }
                  to {
                    opacity: 1;
                    transform: translateY(0);
                  }
                }
              `
          )}
          src={image.src}
          alt={image.altText}
        />
      ))}
    </div>
  )
}
